import {
  createStyles,
  Typography,
  withStyles,
  WithStyles
} from '@material-ui/core';
import moment from 'moment-timezone';
import React from 'react';
import Moment from 'react-moment';

const styles = () =>
  createStyles({
    time: {
      color: '#f8e200',
      fontSize: '1.25rem',
      marginRight: '1rem'
    },
    dayDate: {
      color: '#f8e200',
      fontSize: '2rem',
      marginBottom: '15px'
    },
    timeZone: {
      fontSize: '1.2rem',
      marginLeft: '10px',
      display: 'inline',
      color: '#f8e200'
    }
  });

interface IClock extends WithStyles<typeof styles> {
  timezone: string;
}

const Clock: React.FC<IClock> = (props: IClock) => {
  const { classes, timezone } = props;

  const now = moment().format('LL');
  const day = moment().format('dddd');
  let defaultTimezone = moment.tz.guess();
  if (!defaultTimezone) {
    defaultTimezone = 'Etc/Greenwich';
  }
  const timeZone = timezone ? timezone : defaultTimezone;
  return (
    <div>
      <Typography className={classes.dayDate}>{day}</Typography>
      <Typography className={classes.dayDate}>{now}</Typography>
      <Moment interval={1000} format={'YYYY:MM:dd HH:mm:ss'} tz={timeZone} />
      <Typography className={classes.timeZone}>
        {moment.tz(timeZone).format('z')}
      </Typography>
    </div>
  );
};

export default withStyles(styles)(Clock);
